<template>
  <v-container class="p-2">
    <OverlayPageVue :showOverlay="loader" />
    <v-card flat>
      <v-row no-gutters>
        <v-col cols="2" class="m-auto">
          <img
            src="../../../assets/master_logo.png"
            alt="QQPay"
            style="max-height: 80px; max-width: 160px"
          />
        </v-col>
        <v-col cols="4">
          <p class="font-weight-bold ma-0 pa-0">QQ Pay Sdn Bhd</p>
          <p class="ma-0 pa-0">
            Level 20, Menara 1 Sentrum, 201, Jalan Tun Sambanthan,
            <br />
            Brickfields,50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
          </p>
          <a href="https://www.qqpay.my/" target="_blank">www.qqpay.io</a>
        </v-col>
        <v-col cols="3">
          <p class="ma-0 pa-0">
            PIN NUMBER:<span class="font-weight-bold">
              {{
                this.transactionDetails.txn_data &&
                this.transactionDetails.txn_data.pin_umber
              }}</span
            >
          </p>
          <p class="ma-0 pa-0">
            Transaction ID:<span class="font-weight-bold">
              {{
                this.transactionDetails.txn_data &&
                this.transactionDetails.txn_data.txn_id
              }}</span
            >
          </p>
          <p>
            Transaction Date: {{ this.transactionDetails.txn_data.txn_date }}
          </p>
          <p
            class="ma-0 pa-0"
            v-if="this.transactionDetails.txn_data.receiver_cpay_pinnumber"
          >
            Cash Pickup Pin Number:<span class="font-weight-bold">{{
              this.transactionDetails.txn_data.receiver_cpay_pinnumber
            }}</span>
          </p>
        </v-col>
        <v-col cols="2" class="mt-3">
          <div class="text-center">
            <v-menu :close-on-content-click="false" offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  class="text-capitalize"
                  depressed
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  More Options
                  <v-icon class="ms-1" small>mdi-menu-down-outline</v-icon>
                </v-btn>
              </template>

              <v-card class="m-auto">
                <v-list class="d-flex ma-0 px-3">
                  <v-btn
                    link
                    @click="transactionReport()"
                    color="primary"
                    outlined
                    small
                    depressed
                  >
                    <v-list-item-title>
                      <v-icon small>mdi-printer </v-icon>
                      <span class="caption">View Txn Report</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list>
                <v-list
                  class="d-flex ma-0 px-3"
                  v-if="
                    transactionDetails &&
                    transactionDetails.txn_data.status == 'Cancel'
                  "
                >
                  <v-btn
                    @click="cancelTransaction()"
                    color="primary"
                    outlined
                    small
                    depressed
                  >
                    <v-list-item-title>
                      <v-icon small>mdi-close </v-icon>
                      <span class="caption">Cancel Txn</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list>
                <!-- <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-cancel</v-icon>
                      <span class="caption">Block Txn</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list>
                <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-swap-horizontal</v-icon>
                      <span class="caption">Post to Un-Paid</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list> -->
                <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-information</v-icon>
                      <span class="caption">Settlement Details</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list>
                <!-- <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-file-pdf-box</v-icon>
                      <span class="caption">Export to PDF</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list>
                <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-reload</v-icon>
                      <span class="caption">API log</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list> -->
              </v-card>
            </v-menu>
          </div>
        </v-col>
      </v-row>
      <v-divider class="pa-0 m-auto" style="width: 95%"></v-divider>
      <v-simple-table style="width: 95%" class="m-auto mb-4 pa-2">
        <tr>
          <!-- <td colspan="2">
            Transaction ID:<span class="font-weight-bold">45364534563</span>
          </td> -->
          <td
            colspan="4"
            class="pa-2 white--text font-weight-bold pa-1"
            :style="{
              backgroundColor: getStatusColor(
                this.transactionDetails.txn_data.txn_status
              ),
            }"
          >
            Transaction Status:<span class="font-weight-bold text-uppercase">{{
              this.transactionDetails.txn_data.txn_status
            }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            {{
              this.transactionDetails.txn_data &&
              this.transactionDetails.txn_data.main_sending_partner
            }}
            <br />
            {{
              this.transactionDetails.txn_data &&
              this.transactionDetails.txn_data.sub_sending_partner
            }}
          </td>
          <td>Payout Partner</td>
          <td class="font-weight-bold">
            :
            {{
              this.transactionDetails.txn_data &&
              this.transactionDetails.txn_data.payout_partner
            }}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            {{
              this.transactionDetails.txn_data &&
              this.transactionDetails.txn_data.sub_sending_branch
            }}
          </td>
          <td>Transaction Type</td>
          <td class="font-weight-bold">
            : {{ this.transactionDetails.txn_data.payment_mode }}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <b>
              {{
                this.transactionDetails.txn_data &&
                this.transactionDetails.txn_data.sub_sending_country &&
                this.transactionDetails.txn_data.sub_sending_country.name
              }}</b
            >
          </td>
          <td>Operator Name</td>
          <td class="font-weight-bold">
            : {{ this.transactionDetails.txn_data.created_by }} -{{
              this.transactionDetails.txn_data.created_date
            }}
          </td>
        </tr>
        <tr>
          <td colspan="2"></td>
          <td>Approved By</td>
          <td class="font-weight-bold">
            : {{ this.transactionDetails.txn_data.is_approve_by }} -{{
              this.transactionDetails.txn_data.is_approve_date
            }}
          </td>
        </tr>
      </v-simple-table>
      <v-expansion-panels
        color="primary"
        style="width: 95%"
        class="m-auto"
        multiple
        dense
        focusable
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="font-weight-bold">Sender Information</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <senderinfo
              @senderdataUpdated="getTxnDetailsbyID"
              :senderInfo="transactionDetails.sender_data"
              :txn_status="transactionDetails.txn_data.txn_status"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel v-if="hasOnBehalfData">
          <v-expansion-panel-header>
            <span class="font-weight-bold">On Behalf Information</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <on-behalf-info
              :onBehalfInfo="transactionDetails.on_behalf_data"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="font-weight-bold">Receiver Information</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <reciever-info
              @RecieverDataUpdated="getTxnDetailsbyID"
              :recieverInfo="transactionDetails.receiver_data"
              :txn_status="transactionDetails.txn_data.txn_status"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="font-weight-bold">Transaction Information</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <transaction-info
            @TxnDataUpdated="getTxnDetailsbyID"
              :transactionInfo="transactionDetails.txn_data"
              :txn_status="transactionDetails.txn_data.txn_status"
              :user_type="transactionDetails.sender_data.user_type"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row>
        <v-col
          cols="12"
          md="6"
          :lg="computedLG"
          :class="{ 'custom-class': isCustomClassActive }"
        >
          <matched-info
            :CompliancematchingList="CompliancematchingList"
            :transactionDetails="transactionDetails"
          />
        </v-col>
        <v-col cols="12" md="6" lg="6" class="ms-0 mt-9 pe-4">
          <v-form ref="releaseForm" style="width: 95%" class="m-auto mb-4">
            <v-row class="pa-2" v-if="$route.query.from === 'hold'">
              <v-col cols="4" sm="12" md="6">
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Release"
                  :items="release_items"
                  :rules="validations.releaseRules"
                  v-model="selectedReleaseItem"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="remarks"
                  v-if="selectedReleaseItem === 'Others'"
                  placeholder="Remarks"
                  dense
                  outlined
                  hide-details
                  height="80px"
                  auto-grow
                  :rules="validations.remarksRules"
                  row-height="5"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" v-if="$route.query.from != 'txn'">
                <v-textarea
                  v-model="remarks"
                  placeholder="Remarks"
                  dense
                  outlined
                  height="80px"
                  auto-grow
                  row-height="5"
                  :counter="counter"
                  :rules="[charLimit]"
                  ><template v-slot:v-counter="{ count, max }">
                    {{ count }}/{{ max }} characters entered,
                    {{ max - count }} remaining
                  </template></v-textarea
                >
              </v-col>
            </v-row>
            <v-row no-gutters v-if="$route.query.from != 'txn'">
              <v-col>
                <v-checkbox
                  v-model="accept_txn"
                  label="I acknowledge that this transaction is pending and requires further action."
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row v-if="$route.query.from != 'txn'">
              <v-col class="mb-4">
                <span class="float-right" v-if="$route.query.from === 'hold'">
                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    small
                    :disabled="!accept_txn"
                    @click="updateTxnStatus('Success')"
                  >
                    <v-icon small>mdi-check-circle</v-icon>Release
                    Transaction</v-btn
                  >
                  <v-btn
                    depressed
                    color="warning"
                    class="text-capitalize ms-2"
                    :disabled="!accept_txn"
                    small
                    @click="updateTxnStatus('Hold')"
                    ><v-icon small>mdi-pause-circle-outline</v-icon>Hold
                    Transaction</v-btn
                  >
                  <v-btn
                    depressed
                    color="error"
                    class="text-capitalize ms-2"
                    :disabled="!accept_txn"
                    small
                    @click="updateTxnStatus('Cancel')"
                  >
                    <v-icon small>mdi-close-circle</v-icon>Reject
                    Transaction</v-btn
                  >
                </span>
                <span class="float-right" v-else>
                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    small
                    :disabled="!accept_txn"
                    @click="pushtxnbyId()"
                  >
                    <v-icon small>mdi-check-circle</v-icon>Release
                    Transaction</v-btn
                  >
                </span>
              </v-col>
            </v-row>
            <!-- <v-row v-if="$route.query.from === ''">
                <v-col>
                  <p class="ms-6">
                    Risk Profile Status :
                    <v-chip
                      v-if="$route.query.risk_status"
                      label
                      small
                      :color="returnColor($route.query.risk_status)"
                    >
                      {{ $route.query.risk_status }}:
                      <strong
                        >{{
                          transactionDetails.txn_data &&
                          transactionDetails.txn_data.risk_percentage
                            ? transactionDetails.txn_data.risk_percentage
                            : 0
                        }}
                        %</strong
                      >
                    </v-chip>
      
                    <v-btn
                      @click="
                        $router.push({
                          name: 'Risk Profiling',
                          query: {
                            list: transactionDetails.txn_data.risk_match,
                            pin_no: transactionDetails.txn_data.pin_umber,
                            percentage: transactionDetails.txn_data.risk_percentage,
                            id: transactionDetails.sender_data.user_id,
                          },
                        })
                      "
                      small
                      text
                      color="primary"
                      >View Details</v-btn
                    >
                  </p>
                </v-col>
              </v-row> -->
          </v-form>
        </v-col>
      </v-row>
      <txn-comments
        :ref_number="transactionDetails.txn_data && transactionDetails.txn_data.pin_umber"
      />
    </v-card>
  </v-container>
</template>

<script>
import Senderinfo from "./TransactionDetails/Senderinfo.vue";
import OnBehalfInfo from "./TransactionDetails/OnBehalfInfo.vue";
import RecieverInfo from "./TransactionDetails/RecieverInfo.vue";
import TransactionInfo from "./TransactionDetails/TransactionInfo.vue";
import TxnComments from "./TransactionDetails/TxnComments.vue";
import MatchedInfo from "@/components/compliance/SuspiciousHoldList/SuspiciousTxnhold/TransactionDetails/MatchedInfo";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "../../../utils/OverlayPage.vue";
import PaymentService from "@/services/PaymentService/paymentService.js";
import CommonService from "@/services/CommonService/commonService.js";
import userService from "@/services/UserService/userService.js";
import axios from "axios";
export default {
  name: "Hold Details",
  data() {
    return {
      transactionDetails: {},
      release_items: [],
      counter: 200,
      charLimit: (v) => {
        if (v && v.length > 200) {
          return "Text must be 200 characters or less";
        } else if (!v) {
          return "Required";
        } else {
          return true;
        }
      },
      remarks: "",
      loader: false,
      accept_txn: false,
      isCustomClassActive: false,
      selectedReleaseItem: null,
      CompliancematchingList: [],
      validations: {
        releaseRules: [(v) => !!v || "Required"],
        remarksRules: [(v) => !!v || "Rquired"],
      },
    };
  },
  mixins: [alerts],
  components: {
    TransactionInfo,
    RecieverInfo,
    Senderinfo,
    OnBehalfInfo,
    TxnComments,
    OverlayPageVue,
    MatchedInfo,
  },
  computed: {
    hasOnBehalfData() {
      const onBehalfData = this.transactionDetails.on_behalf_data;

      if (!onBehalfData || typeof onBehalfData !== "object") {
        return false;
      }

      return Object.values(onBehalfData).some((value) => {
        if (value && typeof value === "object") {
          return Object.values(value).some(
            (nestedValue) =>
              nestedValue !== null &&
              nestedValue !== undefined &&
              nestedValue !== ""
          );
        }

        return value !== null && value !== undefined && value !== "";
      });
    },
    computedLG() {
      return this.isCustomClassActive ? 12 : 6;
    },
  },
  mounted() {
    console.log(this.$route.query.id);
    if (this.$route.query.from == "txn") {
      this.isCustomClassActive = true;
    } else {
      this.isCustomClassActive = false;
    }

    if (this.$route.query.id) {
      this.getTxnDetailsbyID();
      this.getCopmlianceMatching();
    }
    this.getReleaseRemarks();
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case "Hold":
          return "#ff6b00"; // Primary color
        case "Paid":
          return "green"; // Success color
        case "Failed":
          return "red"; // Error color
        case "Cancel":
          return "red";
        default:
          return "#1477bb"; // Default color
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 300);
    },
    returnColor(val) {
      if (val.toLowerCase() == "medium") {
        return "orange";
      } else if (val.toLowerCase() == "high") {
        return "error";
      } else if (val.toLowerCase() == "low") {
        return "success";
      }
      return;
    },
    async getCopmlianceMatching() {
      try {
        const responseData = await userService.getCopmlianceMatching(
          this.$route.query.payment_id
        );
        if (responseData && responseData.data.status_code === 200) {
          this.CompliancematchingList = responseData.data.data;
          console.log("data found", responseData);
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    async pushtxnbyId() {
      const pin_number = this.$route.query.payment_id;
      const validate = this.$refs.releaseForm.validate();
      if (validate) {
        this.loader = true;
        try {
          const responseData = await axios.get(
            `${process.env.VUE_APP_CRONE_SERVICE}/api/v1/txn/push-transaction-by-pin?pin_number=${pin_number}&remarks=${this.remarks}`,

            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
                accept: "application/json",
              },
            }
          );
          if (responseData?.data?.status_code === 200) {
            this.$router.push({
              path: "/TransPush",
              query: {
                istodaytnx: false,
              },
            });
            this.loader = false;
            this.showAlertSuccess(
              `Transaction Pushed : ${responseData.data.message}`
            );
            this.getpushTransactions("false");
          } else {
            this.loader = false;
            this.showAlertError(
              `Transaction pushed : ${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`
            );
          }
        } catch (e) {
          this.loader = false;
          console.log(e);
          this.showAlertError(`Transaction pushed : Something went wrong`);
        }
      }
    },
    async getReleaseRemarks() {
      try {
        const responseData = await CommonService.getRemarks();
        if (responseData && responseData.data.status_code === 200) {
          this.release_items = responseData.data.data.map((i) => i.value);
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getReleaseRemarks();
        // }
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async updateTxnStatus(status) {
      let remarks;
      if (this.$route.query.from === "hold") {
        remarks =
          this.selectedReleaseItem === "Others"
            ? this.remarks
            : this.selectedReleaseItem;
      } else {
        remarks = this.remarks;
      }

      const customer_id = this.transactionDetails.sender_data.customer_id;
      const id = this.$route.query.id;
      const validate = this.$refs.releaseForm.validate();
      if (validate) {
        this.loader = true;
        try {
          const responseData = await PaymentService.updateTxn(
            id,
            customer_id,
            status,
            remarks
          );
          if (responseData && responseData.data.status_code === 200) {
            if (this.$route.query.from === "hold") {
              this.$router.push({
                path: "/TransHoldpage",
                query: {
                  istodaytnx: false,
                },
              });
            } else {
              this.$router.push({
                path: "/TransPush",
                query: {
                  istodaytnx: false,
                },
              });
            }
            this.loader = false;
            this.$refs.releaseForm.reset();
            this.showPopup = false;
            this.showAlertSuccess(responseData.data.message);
            console.log("taxes", responseData);
          }
          // else if (responseData.data.status_code === 401) {
          //   this.loader = false;
          //   this.returnNewToken();
          //   this.updateTxnStatus();
          // }
          else {
            this.loader = false;
            this.showAlertError(`Failed: ${responseData.data.message}`);
          }
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }
      }
    },
    async getTxnDetailsbyID() {
      this.loader = true;
      try {
        const responseData = await PaymentService.getTxnDetails(
          this.$route.query.id
        );
        if (responseData && responseData.data.status_code === 200) {
          console.log(responseData.data);
          this.transactionDetails = { ...responseData.data.data[0] };
          console.log("kill", this.transactionDetails);
          this.stoploader();
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTxnDetailsbyID();
        // }
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
          this.loader = false;
        }
        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    transactionReport() {
      this.$router.push({
        path: "/TransactionReport",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    cancelTransaction() {
      this.$router.push({
        path: "/cancelTransaction",
        query: {
          id: this.$route.query.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
// table,
// th,
// td {
//   border-bottom: 1px solid rgb(195, 195, 195);
//   border-collapse: collapse;
//   padding: 5px;
// }
.primary-bg {
  background-color: rgb(230, 228, 228);
}
.v-list-item {
  justify-content: center;
  padding: 0px;
}
.min_width {
  min-width: 300px;
}
</style>
